
export default function  NotFound(){
  
  return (
    <div>
        404Not found
    </div>
  )
}